<div *ngIf="wrapped" class="form-group" [ngClass]="wrappedClass">
  <input type="checkbox" id="{{name}}" name="{{name}}" [(ngModel)]="model" [ngClass]="class" [attr.disabled]="disabled ? 'disabled' : null" (ngModelChange)="modelChanged($event)" />
  <label for="{{name}}"> {{label || (name | stringSpacer)}}</label>
</div>
<input *ngIf="!wrapped" type="checkbox" id="{{name}}" name="{{name}}" [ngClass]="class" [(ngModel)]="model" [attr.disabled]="disabled ? 'disabled' : null"
  (ngModelChange)="modelChanged($event)" />